export const getListOnlineService = state => {
  return state.onlineService.data;
};

export const getOnlineServiceById = (state, id) => {
  const data = state.onlineService.data;
  if (data && data.length > 0) {
    const onlineService = data.filter(item => item.id === id);
    if (onlineService && onlineService.length > 0) {
      return onlineService[0];
    }
  }
  return null;
};
